import React, { useState } from "react";
import { Button, Modal, Input, message, notification } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { PageLoader } from "../../../../Services/PageLoader";

const ApproveReject = ({ id, detailType, redirect }) => {
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate();

  const handleApprove = async () => {
    const payload = detailType.map((type) => ({
      detail_type: type,
      is_approved: true,
    }));
    try {
      setIsLoading(true);
      const { data } = await axios.post("/api/employees/approve-reject", {
        employee_id: id,
        sections: payload,
      });

      if (data?.success) {
        setIsRejectModalOpen(false);
        setRejectionReason("");
        api.success({ message: data.message, placement: "top" });
        navigate(`/admin/employees-verification/${id}/${redirect}`);
        return true;
      } else {
        api.error({ message: data.message, placement: "top" });
        // if (
        //   data?.message === "No changes made. Employee or sections not found."
        // ) {
        //   navigate(`/admin/employees-view/${id}/${redirect}`);
        // }
        return true;
      }
    } catch (error) {
      console.error(error);
      message.error("Approval failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleReject = async () => {
    if (!rejectionReason.trim()) return;

    const payload = detailType.map((type) => ({
      detail_type: type,
      is_approved: false,
      reason: rejectionReason,
    }));

    try {
      setIsLoading(true);
      const { data } = await axios.post("/api/employees/approve-reject", {
        employee_id: id,
        sections: payload,
      });
      if (data?.success) {
        setIsRejectModalOpen(false);
        setRejectionReason("");
        api.success({ message: data.message, placement: "top" });
        navigate(`/admin/employees-verification/${id}/${redirect}`);
        return true;
      } else {
        api.error({ message: data.message, placement: "top" });

        if (
          data?.message === "No changes made. Employee or sections not found."
        ) {
          navigate(`/admin/employees-verification/${id}/${redirect}`);
        }
        return true;
      }

      //   message.success("Employee rejected successfully!");
    } catch (error) {
      console.error(error);
      message.error("Rejection failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {contextHolder}

      <div className="space-x-4 flex justify-end mt-4">
        <Button
          type="success"
          className="bg-green-500 text-white"
          loading={isLoading}
          onClick={handleApprove}
        >
          ✓ Approves
        </Button>
        <Button
          type="danger"
          color="red"
          className="bg-red-500 text-white"
          onClick={() => setIsRejectModalOpen(true)}
        >
          ✗ Reject
        </Button>
        <Modal
          title={<span className="text-red-600">Rejection Reason</span>}
          visible={isRejectModalOpen}
          onCancel={() => setIsRejectModalOpen(false)}
          footer={[
            <Button
              key="submit"
              type="danger"
              className="bg-red-500 text-white pl-4 pr-4"
              onClick={handleReject}
              disabled={!rejectionReason.trim()}
              loading={isLoading}
            >
              Send
            </Button>,
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Write here..."
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
          />
        </Modal>
      </div>
    </>
  );
};

export default ApproveReject;
